import { hr } from 'date-fns/locale';

export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Home',
      active: true,
      icon: 'globe',
      to: '/dashboard/analytics'
    },
    {
      name: 'Holidays',
      icon: 'calendar-day',
      to: '/app/calendar',
      active: true
    },
    {
      name: 'Calendar',
      icon: 'calendar-alt',
      to: '/app/calendar',
      active: true
    },
    {
      name: 'Documents',
      icon: 'book-open',
      to: '/app/calendar',
      active: true
    },
    {
      name: 'Dashboard',
      active: false,
      icon: 'chart-pie',
      children: [
        {
          name: 'Default',
          to: '/',
          exact: true,
          active: false
        },
        {
          name: 'Analytics',
          to: '/dashboard/analytics',
          active: false
        },
        {
          name: 'CRM',
          to: '/dashboard/crm',
          active: false
        },
        {
          name: 'E Commerce',
          to: '/dashboard/e-commerce',
          active: false
        },
        {
          name: 'Management',
          to: '/dashboard/project-management',
          active: false
        },
        {
          name: 'SaaS',
          to: '/dashboard/saas',
          active: false
        }
      ]
    }
  ]
};
export const financialAppRoutes = {
  label: 'Accountancy',
  labelDisable: false,
  children: [
    {
      name: 'Budget',
      icon: 'dollar-sign',
      to: '/app/budget',
      active: true
    },
    {
      name: 'Banking',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'Invoices',
      icon: 'file-alt',
      to: '/app/invoices',
      active: true
    },
    {
      name: 'Bills',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'Expenses',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'Dividents',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'VAT',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'Corporation Tax',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    },
    {
      name: 'Reports',
      icon: 'file-alt',
      to: '/app/expense',
      active: true
    }
  ]
};
export const systemRoutes = {
  label: 'System',
  labelDisable: true,
  children: [
    {
      name: 'Support',
      icon: 'life-ring',
      to: '/app/support/tickets',
      active: false
    },
    {
      name: 'Logout',
      icon: 'sign-out-alt',
      to: '/authentication/simple/logout',
      active: false
    }
  ]
};
export const companyRoutes = {
  label: 'Company',
  labelDisable: false,
  children: [
    {
      name: 'Directories',
      icon: 'book-open',
      to: '/social/directory',
      active: true
    }
  ]
};
export const wodRoutes = {
  roles: ['WOD', 'WOD-ADMIN', 'WOD-COACH'],
  label: 'WOD',
  labelDisable: false,
  children: [
    {
      name: 'Dashboard',
      icon: 'chart-pie',
      to: '/app/wod/dashboard',
      active: true
    },
    {
      name: 'My Bookings',
      icon: 'book',
      to: '/app/wod/bookings',
      active: true
    },
    {
      name: 'Timetable',
      icon: 'calendar-alt',
      to: '/app/wod/timetable',
      active: true
    },
    {
      name: 'Programming',
      icon: 'dumbbell',
      to: '/app/wod/programming',
      active: true
    },
    {
      name: 'Training History',
      icon: 'clipboard-list',
      to: '/app/wod/training-history',
      active: true,
      roles: ['WOD']
    },
    {
      name: 'Memberships',
      icon: 'credit-card',
      to: '/app/wod/memberships',
      active: true,
      roles: ['WOD']
    },
    {
      name: 'Coach',
      icon: 'lock',
      roles: ['WOD-COACH'],
      children: [
        {
          name: 'Classes',
          icon: 'dumbbell',
          to: '/app/wod/admin/classes',
          active: true
        },
        {
          name: 'Birthdays',
          icon: 'birthday-cake',
          to: '/app/wod/birthdays',
          active: true
        },        
      ]
    },
    {
      name: 'Admin',
      icon: 'lock',
      roles: ['WOD-ADMIN'],
      children: [
        {
          name: 'Classes',
          icon: 'dumbbell',
          to: '/app/wod/admin/classes',
          active: true
        },
        {
          name: 'Programs',
          icon: 'chart-pie',
          to: '/app/wod/programs',
          active: true
        },
        {
          name: 'Class Templates',
          icon: 'file-alt',
          to: '/app/wod/templates',
          active: true
        },
        {
          name: 'Members',
          icon: 'users',
          to: '/app/wod/members',
          active: true
        },
        {
          name: 'Birthdays',
          icon: 'birthday-cake',
          to: '/app/wod/birthdays',
          active: true
        },
        {
          name: 'Goals',
          icon: 'flag',
          to: '/app/wod/goals',
          active: true
        },
        {
          name: 'Payments',
          icon: 'credit-card',
          to: '/app/wod/settings/payments',
          active: true
        }
      ]
    },
    {
      name: 'My Details',
      icon: 'user',
      to: '/app/wod/my-details',
      active: true
    }
  ]
};
export const hospitalityRoutes = {
  label: 'Hospitality',
  labelDisable: false,
  children: [
    {
      name: 'Reservations',
      icon: 'calendar-check',
      to: '/app/reservations',
      active: true
    },
    {
      name: 'Rooms',
      icon: 'book-open',
      to: '/app/rooms',
      active: true
    },
    {
      name: 'Events',
      icon: 'calendar-day',
      to: '/app/events',
      active: true
    },
    {
      name: 'Contacts',
      icon: 'user-plus',
      to: '/app/contacts',
      active: true
    }
  ]
};

export const hrAppRoutes = {
  label: 'HR',
  labelDisable: false,
  children: [
    {
      name: 'Home',
      active: true,
      icon: 'home',
      to: '/'
    },
    {
      name: 'Holidays',
      icon: 'rocket',
      to: '/app/holidays',
      active: true
    },
    {
      name: 'People',
      icon: 'users',
      roles: ['HR-ADMIN'],
      active: true,
      children: [
        {
          name: 'Employees',
          icon: 'users',
          to: 'social/directory/user-list',
          active: true
        },
        {
          name: 'Onboarding',
          icon: 'user-plus',
          to: '/app/onboarding',
          active: true
        }
      ]
    },
    {
      name: 'Groups',
      icon: 'user-friends',
      to: '/app/groups',
      active: true
    },
    {
      name: 'Contacts',
      icon: 'user-plus',
      to: '/app/contacts',
      active: true
    },
    {
      name: 'Leads',
      icon: 'user-plus',
      to: '/app/leads',
      active: true,
      roles: ['HR-ADMIN']
    },
    /*{
      name: 'Payroll',
      icon: 'book-open',
      to: '/app/payroll',
      active: true
    },*/
    {
      name: 'Calendar',
      icon: 'calendar-alt',
      to: '/app/calendar',
      active: true
    },
    {
      name: 'Annoucements',
      icon: 'bullhorn',
      to: '/app/annoucements',
      active: true
    },
    {
      name: 'Performance',
      icon: 'chart-line',
      to: '/app/performance',
      active: true,
      children: [
        {
          name: 'Feedbacks',
          icon: 'comments',
          to: '/app/performance/#feedbacks',
          active: true
        },
        {
          name: 'Goals',
          icon: 'flag',
          to: '/app/performance/#goals',
          active: true
        },
        {
          name: 'Reviews',
          icon: 'check-circle',
          to: '/app/performance/#reviews',
          active: true
        }
      ]
    },
    {
      name: 'Job Vacancies',
      icon: 'file-alt',
      to: '/app/roles',
      active: true,
      roles: ['HR-ADMIN'],
      children: [
        {
          name: 'View All Roles',
          icon: 'list',
          to: '/app/roles',
          active: false
        },
        {
          name: 'Candidates',
          icon: 'user',
          to: '/app/roles/candidates',
          active: false
        },
        {
          name: 'Salary levels',
          icon: 'dollar-sign',
          to: '/app/roles/salarylevels',
          active: false
        }
      ]
    },
    {
      name: 'Documents',
      icon: 'file-alt',
      to: '/app/documents',
      active: true
    },
    {
      name: 'Software Licences',
      icon: 'file-alt',
      to: '/app/software-licences',
      active: true,
      roles: ['HR-ADMIN']
    },
    {
      name: 'Notifications',
      icon: 'bell',
      to: '/app/notifications',
      active: true
    },
    {
      name: 'My Details',
      icon: 'book',
      to: '/social/directory/my-details',
      active: false
    }
  ]
};
export const appRoutes = {
  label: 'app',
  children: [
    {
      name: 'Calendar',
      icon: 'calendar-alt',
      to: '/app/calendar',
      active: false
    },
    {
      name: 'Chat',
      icon: 'comments',
      to: '/app/chat',
      active: false
    },
    {
      name: 'Email',
      icon: 'envelope-open',
      active: false,
      children: [
        {
          name: 'Inbox',
          to: '/email/inbox',
          active: false
        },
        {
          name: 'Email detail',
          to: '/email/email-detail',
          active: false
        },
        {
          name: 'Compose',
          to: '/email/compose',
          active: false
        }
      ]
    },
    {
      name: 'Events',
      icon: 'calendar-day',
      active: true,
      children: [
        {
          name: 'Create an event',
          to: '/events/create-an-event',
          active: true
        },
        {
          name: 'Event detail',
          to: '/events/event-detail',
          active: true
        },
        {
          name: 'Event list',
          to: '/events/event-list',
          active: false
        }
      ]
    },
    {
      name: 'E Commerce',
      icon: 'shopping-cart',
      active: false,
      children: [
        {
          name: 'Product',
          active: false,
          children: [
            {
              name: 'Product list',
              to: '/e-commerce/product/product-list',
              active: false
            },
            {
              name: 'Product grid',
              to: '/e-commerce/product/product-grid',
              active: false
            },
            {
              name: 'Product details',
              to: '/e-commerce/product/product-details',
              active: false
            }
          ]
        },
        {
          name: 'Orders',
          active: false,
          children: [
            {
              name: 'Order list',
              to: '/e-commerce/orders/order-list',
              active: false
            },
            {
              name: 'Order details',
              to: '/e-commerce/orders/order-details',
              active: false
            }
          ]
        },
        {
          name: 'Customers',
          to: '/e-commerce/customers',
          active: false
        },
        {
          name: 'Customer details',
          to: '/e-commerce/customer-details',
          active: false
        },
        {
          name: 'Shopping cart',
          to: '/e-commerce/shopping-cart',
          active: false
        },
        {
          name: 'Checkout',
          to: '/e-commerce/checkout',
          active: false
        },
        {
          name: 'Billing',
          to: '/e-commerce/billing',
          active: false
        },
        {
          name: 'Invoice',
          to: '/e-commerce/invoice',
          active: false
        }
      ]
    },
    {
      name: 'Kanban',
      icon: ['fab', 'trello'],
      to: '/app/kanban',
      active: false
    },
    {
      name: 'Social',
      icon: 'share-alt',
      active: false,
      children: [
        {
          name: 'Feed',
          to: '/social/feed',
          active: false
        },
        {
          name: 'Activity log',
          to: '/social/activity-log',
          active: false
        },
        {
          name: 'Notifications',
          to: '/social/notifications',
          active: false
        },
        {
          name: 'Followers',
          to: '/social/followers',
          active: false
        }
      ]
    }
  ]
};

export const pagesRoutes = {
  label: 'pages',
  children: [
    {
      name: 'Starter',
      icon: 'flag',
      to: '/pages/starter',
      active: false
    },
    {
      name: 'Landing',
      icon: 'globe',
      to: '/landing',
      active: false
    },
    {
      name: 'Authentication',
      icon: 'lock',
      active: false,
      children: [
        {
          name: 'Simple',
          active: false,
          children: [
            {
              name: 'Login',
              to: '/authentication/simple/login',
              active: false
            },
            {
              name: 'Logout',
              to: '/authentication/simple/logout',
              active: false
            },
            {
              name: 'Register form',
              to: '/authentication/registration-form',
              active: false
            },
            {
              name: 'Register',
              to: '/authentication/simple/register',
              active: false
            },
            {
              name: 'Forgot password',
              to: '/authentication/simple/forgot-password',
              active: false
            },
            {
              name: 'Confirm mail',
              to: '/authentication/simple/confirm-mail',
              active: false
            },
            {
              name: 'Reset password',
              to: '/authentication/simple/reset-password',
              active: false
            },
            {
              name: 'Lock screen',
              to: '/authentication/simple/lock-screen',
              active: false
            }
          ]
        },
        {
          name: 'Card',
          active: false,
          children: [
            {
              name: 'Login',
              to: '/authentication/card/login',
              active: false
            },
            {
              name: 'Logout',
              to: '/authentication/card/logout',
              active: false
            },
            {
              name: 'Register',
              to: '/authentication/card/register',
              active: false
            },
            {
              name: 'Forgot password',
              to: '/authentication/card/forgot-password',
              active: false
            },
            {
              name: 'Confirm mail',
              to: '/authentication/card/confirm-mail',
              active: false
            },
            {
              name: 'Reset password',
              to: '/authentication/card/reset-password',
              active: false
            },
            {
              name: 'Lock screen',
              to: '/authentication/card/lock-screen',
              active: false
            }
          ]
        },
        {
          name: 'Split',

          active: false,
          children: [
            {
              name: 'Login',
              to: '/authentication/split/login',
              active: false
            },
            {
              name: 'Logout',
              to: '/authentication/split/logout',
              active: false
            },
            {
              name: 'Register',
              to: '/authentication/split/register',
              active: false
            },
            {
              name: 'Forgot password',
              to: '/authentication/split/forgot-password',
              active: false
            },
            {
              name: 'Confirm mail',
              to: '/authentication/split/confirm-mail',
              active: false
            },
            {
              name: 'Reset password',
              to: '/authentication/split/reset-password',
              active: false
            },
            {
              name: 'Lock screen',
              to: '/authentication/split/lock-screen',
              active: false
            }
          ]
        },
        {
          name: 'Wizard',
          to: '/authentication/wizard',
          active: false
        },
        {
          name: 'Modal',
          to: '/authentication-modal',
          active: false
        }
      ]
    },
    {
      name: 'User',
      icon: 'user',
      active: false,
      children: [
        {
          name: 'Profile',
          to: '/user/profile',
          active: false
        },
        {
          name: 'Settings',
          to: '/user/settings',
          active: false
        }
      ]
    },
    {
      name: 'Pricing',
      icon: 'tags',
      active: false,
      children: [
        {
          name: 'Pricing default',
          to: '/pricing/pricing-default',
          active: false
        },
        {
          name: 'Pricing alt',
          to: '/pricing/pricing-alt',
          active: false
        }
      ]
    },
    {
      name: 'Faq',
      icon: 'question-circle',
      active: false,
      children: [
        {
          name: 'Faq basic',
          to: '/faq/faq-basic',
          active: false
        },
        {
          name: 'Faq alt',
          to: '/faq/faq-alt',
          active: false
        },
        {
          name: 'Faq accordion',
          to: '/faq/faq-accordion',
          active: false
        }
      ]
    },
    {
      name: 'Errors',
      active: false,
      icon: 'exclamation-triangle',
      children: [
        {
          name: '404',
          to: '/errors/404',
          active: false
        },
        {
          name: '500',
          to: '/errors/500',
          active: false
        }
      ]
    },
    {
      name: 'Miscellaneous',
      icon: 'thumbtack',
      active: false,
      children: [
        {
          name: 'Associations',
          to: '/miscellaneous/associations',
          active: false
        },
        {
          name: 'Invite people',
          to: '/miscellaneous/invite-people',
          active: false
        },
        {
          name: 'Privacy policy',
          to: '/miscellaneous/privacy-policy',
          active: false
        }
      ]
    }
  ]
};

export const modulesRoutes = {
  label: 'Modules',
  children: [
    {
      name: 'Forms',
      active: false,
      icon: 'file-alt',
      children: [
        {
          name: 'Basic',
          active: false,
          children: [
            {
              name: 'Form control',
              to: '/forms/basic/form-control',
              active: false
            },
            {
              name: 'Input group',
              to: '/forms/basic/input-group',
              active: false
            },
            {
              name: 'Select',
              to: '/forms/basic/select',
              active: false
            },
            {
              name: 'Checks',
              to: '/forms/basic/checks',
              active: false
            },
            {
              name: 'Range',
              to: '/forms/basic/range',
              active: false
            },
            {
              name: 'Layout',
              to: '/forms/basic/layout',
              active: false
            }
          ]
        },
        {
          name: 'Advance',
          active: false,
          children: [
            {
              name: 'Advance select',
              to: '/forms/advance/advance-select',
              active: false
            },
            {
              name: 'Date picker',
              to: '/forms/advance/date-picker',
              active: false
            },
            {
              name: 'Editor',
              to: '/forms/advance/editor',
              active: false
            },
            {
              name: 'Emoji button',
              to: '/forms/advance/emoji-button',
              active: false
            },
            {
              name: 'File uploader',
              to: '/forms/advance/file-uploader',
              active: false
            },
            {
              name: 'Rating',
              to: '/forms/advance/rating',
              active: false
            }
          ]
        },
        {
          name: 'Floating labels',
          to: '/forms/floating-labels',
          active: false
        },
        {
          name: 'Wizard',
          to: '/forms/wizard',
          active: false
        },
        {
          name: 'Validation',
          to: '/forms/validation',
          active: false
        }
      ]
    },
    {
      name: 'Tables',
      icon: 'table',
      active: false,
      children: [
        {
          name: 'Basic tables',
          to: '/tables/basic-tables',
          active: false
        },
        {
          name: 'Advance tables',
          to: '/tables/advance-tables',
          active: false
        }
      ]
    },
    {
      name: 'Charts',
      icon: 'chart-line',
      active: false,
      children: [
        {
          name: 'Chartjs',
          to: '/charts/chartjs',
          active: false
        },
        {
          name: 'ECharts',
          active: false,
          children: [
            {
              name: 'How to use',
              to: '/charts/echarts/how-to-use',
              active: false
            },
            {
              name: 'Line charts',
              to: '/charts/echarts/line-charts',
              active: false
            },
            {
              name: 'Bar charts',
              to: '/charts/echarts/bar-charts',
              active: false
            },
            {
              name: 'Candlestick charts',
              to: '/charts/echarts/candlestick-charts',
              active: false
            },
            {
              name: 'Geo map',
              to: '/charts/echarts/geo-map',
              active: false
            },
            {
              name: 'Scatter charts',
              to: '/charts/echarts/scatter-charts',
              active: false
            },
            {
              name: 'Pie charts',
              to: '/charts/echarts/pie-charts',
              active: false
            },
            {
              name: 'Radar charts',
              to: '/charts/echarts/radar-charts',
              active: false
            },
            {
              name: 'Heatmap charts',
              to: '/charts/echarts/heatmap-charts',
              active: false
            }
          ]
        }
      ]
    },
    {
      name: 'Icons',
      active: false,
      icon: 'shapes',
      children: [
        {
          name: 'Font awesome',
          to: '/icons/font-awesome',
          active: false
        },
        {
          name: 'React icons',
          to: '/icons/react-icons',
          active: false
        }
      ]
    },
    {
      name: 'Maps',
      icon: 'map',
      active: false,
      children: [
        {
          name: 'Google map',
          to: '/maps/google-map',
          active: false
        },
        {
          name: 'Leaflet map',
          to: '/maps/leaflet-map',
          active: false
        }
      ]
    },
    {
      name: 'Components',
      active: false,
      icon: 'puzzle-piece',
      children: [
        {
          name: 'Alerts',
          to: '/components/alerts',
          active: false
        },
        {
          name: 'Accordion',
          to: '/components/accordion',
          active: false
        },
        {
          name: 'Animated icons',
          to: '/components/animated-icons',
          active: false
        },
        {
          name: 'Background',
          to: '/components/background',
          active: false
        },
        {
          name: 'Badges',
          to: '/components/badges',
          active: false
        },
        {
          name: 'Breadcrumbs',
          to: '/components/breadcrumb',
          active: false
        },
        {
          name: 'Buttons',
          to: '/components/buttons',
          active: false
        },
        {
          name: 'Calendar',
          to: '/components/calendar',
          active: false
        },
        {
          name: 'Cards',
          to: '/components/cards',
          active: false
        },
        {
          name: 'Carousel',
          active: false,
          children: [
            {
              name: 'Bootstrap',
              to: '/components/carousel/bootstrap',
              label: 'bootstrap-carousel',
              active: false
            },
            {
              name: 'Slick',
              to: '/components/carousel/slick',
              active: false
            }
          ]
        },
        {
          name: 'Collapse',
          to: '/components/collapse',
          active: false
        },
        {
          name: 'Cookie notice',
          to: '/components/cookie-notice',
          active: false
        },
        {
          name: 'Countup',
          to: '/components/countup',
          active: false
        },
        {
          name: 'Draggable',
          to: '/components/draggable',
          active: false
        },
        {
          name: 'Dropdowns',
          to: '/components/dropdowns',
          active: false
        },
        {
          name: 'List group',
          to: '/components/list-group',
          active: false
        },
        {
          name: 'Modals',
          to: '/components/modals',
          active: false
        },
        {
          name: 'Offcanvas',
          to: '/components/offcanvas',
          active: false
        },
        {
          name: 'Navs & Tabs',
          active: false,
          children: [
            {
              name: 'Navs',
              to: '/components/navs-and-tabs/navs',
              active: false
            },
            {
              name: 'Navbar',
              to: '/components/navs-and-tabs/navbar',
              active: false
            },
            {
              name: 'Vertical navbar',
              to: '/components/navs-and-tabs/vertical-navbar',
              active: false
            },
            {
              name: 'Top navbar',
              to: '/components/navs-and-tabs/top-navbar',
              active: false
            },
            {
              name: 'Combo navbar',
              to: '/components/navs-and-tabs/combo-navbar',
              active: false
            },
            {
              name: 'Tabs',
              to: '/components/navs-and-tabs/tabs',
              active: false
            }
          ]
        },
        {
          name: 'Pictures',
          active: false,
          children: [
            {
              name: 'Avatar',
              to: '/components/pictures/avatar',
              active: false
            },
            {
              name: 'Images',
              to: '/components/pictures/images',
              active: false
            },
            {
              name: 'Figures',
              to: '/components/pictures/figures',
              active: false
            },
            {
              name: 'Hoverbox',
              to: '/components/pictures/hoverbox',
              active: false
            },
            {
              name: 'Lightbox',
              to: '/components/pictures/lightbox',
              active: false
            }
          ]
        },
        {
          name: 'Progress Bar',
          to: '/components/progress-bar',
          active: false
        },
        {
          name: 'Pagination',
          to: '/components/pagination',
          active: false
        },
        {
          name: 'Placeholder',
          to: '/components/placeholder',
          active: false
        },
        {
          name: 'Popovers',
          to: '/components/popovers',
          active: false
        },
        {
          name: 'Scrollspy',
          to: '/components/scrollspy',
          active: false
        },
        {
          name: 'Search',
          to: '/components/search',
          active: false
        },
        {
          name: 'Spinners',
          to: '/components/spinners',
          active: false
        },
        {
          name: 'Timeline',
          to: '/components/timeline',
          active: false,
          badge: {
            type: 'success',
            text: 'New'
          }
        },
        {
          name: 'Toasts',
          to: '/components/toasts',
          active: false
        },
        {
          name: 'Tooltips',
          to: '/components/tooltips',
          active: false
        },
        {
          name: 'Treeview',
          to: '/components/treeview',
          active: false
        },
        {
          name: 'Typed text',
          to: '/components/typed-text',
          active: false
        },
        {
          name: 'Videos',
          active: false,
          children: [
            {
              name: 'Embed',
              to: '/components/videos/embed',
              active: false
            },
            {
              name: 'React Player',
              to: '/components/videos/react-player',
              active: false
            }
          ]
        }
      ]
    },
    {
      name: 'Utilities',
      active: false,
      icon: 'fire',
      children: [
        {
          name: 'Borders',
          to: '/utilities/borders',
          active: false
        },
        {
          name: 'Colors',
          to: '/utilities/colors',
          active: false
        },
        {
          name: 'Colored links',
          to: '/utilities/colored-links',
          active: false
        },
        {
          name: 'Display',
          to: '/utilities/display',
          active: false
        },
        {
          name: 'Flex',
          to: '/utilities/flex',
          active: false
        },
        {
          name: 'Float',
          to: '/utilities/float',
          active: false
        },
        {
          name: 'Grid',
          to: '/utilities/grid',
          active: false
        },
        {
          name: 'Scroll Bar',
          to: '/utilities/scroll-bar',
          active: false
        },
        {
          name: 'Position',
          to: '/utilities/position',
          active: false
        },
        {
          name: 'Spacing',
          to: '/utilities/spacing',
          active: false
        },
        {
          name: 'Sizing',
          to: '/utilities/sizing',
          active: false
        },
        {
          name: 'Stretched link',
          to: '/utilities/stretched-link',
          active: false
        },
        {
          name: 'Text truncation',
          to: '/utilities/text-truncation',
          active: false
        },
        {
          name: 'Typography',
          to: '/utilities/typography',
          active: false
        },
        {
          name: 'Vertical align',
          to: '/utilities/vertical-align',
          active: false
        },
        {
          name: 'Visibility',
          to: '/utilities/visibility',
          active: false
        }
      ]
    },
    {
      name: 'Widgets',
      icon: 'poll',
      to: '/widgets',
      active: false
    },
    {
      name: 'Multi level',
      active: false,
      icon: 'layer-group',
      children: [
        {
          name: 'Level two',
          active: false,
          children: [
            {
              name: 'Item 1',
              active: false,
              to: '#!'
            },
            {
              name: 'Item 2',
              active: false,
              to: '#!'
            }
          ]
        },
        {
          name: 'Level three',
          active: false,
          children: [
            {
              name: 'Item 3',
              active: false,
              to: '#!'
            },
            {
              name: 'Item 4',
              active: false,
              children: [
                {
                  name: 'Item 5',
                  active: false,
                  to: '#!'
                },
                {
                  name: 'Item 6',
                  active: false,
                  to: '#!'
                }
              ]
            }
          ]
        },
        {
          name: 'Level four',
          active: false,
          children: [
            {
              name: 'Item 6',
              active: false,
              to: '#!'
            },
            {
              name: 'Item 7',
              active: false,
              children: [
                {
                  name: 'Item 8',
                  active: false,
                  to: '#!'
                },
                {
                  name: 'Item 9',
                  active: false,
                  children: [
                    {
                      name: 'Item 10',
                      active: false,
                      to: '#!'
                    },
                    {
                      name: 'Item 11',
                      active: false,
                      to: '#!'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const documentationRoutes = {
  label: 'documentation',
  children: [
    {
      name: 'Getting started',
      icon: 'rocket',
      to: '/documentation/getting-started',
      active: false
    },
    {
      name: 'Customization',
      active: false,
      icon: 'wrench',
      children: [
        {
          name: 'Configuration',
          to: '/documentation/configuration',
          active: false
        },
        {
          name: 'Styling',
          to: '/documentation/styling',
          active: false
        },
        {
          name: 'Dark mode',
          to: '/documentation/dark-mode',
          active: false
        },
        {
          name: 'Plugin',
          to: '/documentation/plugin',
          active: false
        }
      ]
    },
    {
      name: 'Faq',
      icon: 'question-circle',
      to: '/documentation/faq',
      active: false
    },
    {
      name: 'Design file',
      icon: 'palette',
      to: '/documentation/design-file',
      active: false
    },
    {
      name: 'Changelog',
      icon: 'code-branch',
      to: '/changelog',
      active: false
    }
  ]
};

export default [wodRoutes, systemRoutes];
